import { useState } from 'react'
import type { Editor } from 'slate'
import { createEditor } from 'slate'
import { withReact } from 'slate-react'
import { withInit } from './withInit'

export { withCursors, withYHistory } from '@slate-yjs/core'
export { withHistory } from 'slate-history'
export { withDefaultFormatOnBreak } from './withDefaultFormatOnBreak'
export { withGlossary } from './withGlossary'
export { withHtml } from './withHtml'
export { withLinks } from './withLinks'
export { withMentions } from './withMentions'
export { withNormalisedLists } from './withNormalisedLists'
export { withTables } from './withTables'
export { withUploads } from './withUploads'
export { useYjs } from './withYjs'

export type Extension = (editor: Editor) => Editor

export function useEditorWithExtensions(extensions: Extension[]) {
  const [editor] = useState(() => {
    const distinctExtensions = Array.from(
      new Set([withReact, withInit, ...extensions]),
    )
    return distinctExtensions.reduce<Editor>(
      (editor, extension) => extension(editor),
      createEditor(),
    )
  })

  return editor
}
